"use client"; // nécessaire pour useState, useRouter et les événements

import { useState } from 'react';
import Link from 'next/link';
import { Landmark } from 'lucide-react';
import PasswordInput from '@/components/PasswordInput/PasswordInput';
import { useRouter } from 'next/navigation'; // permet de rediriger par le code (router.push)
import styles from './page.module.css';

export default function ConnexionPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const router = useRouter(); // utilisé pour rediriger vers "/" après connexion

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault(); // annule le rechargement de page par défaut du navigateur
    setError("");

    // await : handleSubmit se met en pause jusqu'à réception de la réponse
    // credentials: "include" : envoie les cookies avec la requête
    // sans ça, le navigateur ne transmettrait pas le cookie "token"
    const res = await fetch("/api/auth/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, password }),
      credentials: "include",
    });

    if (res.ok) {
      window.location.href = "/"; // rechargement complet pour que le cookie soit bien envoyé
    } else {
      // res.json() lit le corps de la réponse en flux — d'où le await
      // res lui-même ne contient que les en-têtes (statut, type...)
      const data = await res.json();
      setError(data.detail ?? "Une erreur est survenue");
    }
  }

  return (
    <div className={styles.page}>
      <div className={styles.illustration}>
        <Link href="/">
          <Landmark size={80} color="#2d7a4f" strokeWidth={1.2} />
          <span className={styles.sitename}>Civex</span>
        </Link>
        <p className={styles.tagline}>
          L'annuaire des initiatives civiques en France
        </p>
      </div>

      <div className={styles['form-side']}>
        <div className={styles['form-box']}>
          <h1>Connexion</h1>

          <form onSubmit={handleSubmit}>
            <div className={styles.field}>
              <label htmlFor="email">Adresse email</label>
              <input
                type="email" id="email" name="email"
                placeholder="vous@exemple.com"
                value={email}                              // champ contrôlé par React
                onChange={e => setEmail(e.target.value)}  // met à jour l'état à chaque frappe
                required
              />
            </div>

            <div className={styles.field}>
              <label htmlFor="password">Mot de passe</label>
              <PasswordInput id="password" name="password" placeholder="••••••••" value={password} onChange={e => setPassword(e.target.value)} required />
            </div>

            {error && <p className={styles.error}>{error}</p>}

            <button type="submit" className={styles.btn}>Se connecter</button>

            <div className={styles.links}>
              <Link href="/inscription">Créer un compte</Link>
              <Link href="/mot-de-passe-oublie">Mot de passe oublié ?</Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
